import { FC } from "react";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";

const IsolatedCoverageComparisonWidget: FC = () => (
    <div data-testid="compliance-connect__isolated-coverage-comparison-widget">
        <QESWidget className="w-100">
            <QESWidgetHeader>
                <QESWidgetTitle>Isolated Coverage Comparison</QESWidgetTitle>
            </QESWidgetHeader>
            <QESWidgetContent>
            </QESWidgetContent>
        </QESWidget>
    </div>
);

export default IsolatedCoverageComparisonWidget;
